import roles from './Roles';
import User from '../../../base/enums/user';

const user: User = {
  roles
};

export default user;
